// ABOUTME: Marketing landing page for anonymous visitors
// ABOUTME: Shows app benefits, features, and CTA to signup

import { BookOpenIcon, SwatchIcon, ViewfinderCircleIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { ShirtIcon } from '@/components/icons'

const features = [
  {
    icon: ShirtIcon,
    title: 'Wardrobe Scanner',
    description: 'Organize your closet and track every piece you own',
  },
  {
    icon: BookOpenIcon,
    title: 'Style Education',
    description: "Learn the fundamentals of men's fashion and grooming",
  },
  {
    icon: ViewfinderCircleIcon,
    title: 'Daily Challenges',
    description: 'Build better style habits with gamified challenges',
  },
  {
    icon: SwatchIcon,
    title: 'Outfit Builder',
    description: 'Create and save perfect outfit combinations',
  },
]

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-bg">
      {/* Hero Section */}
      <section className="px-5 pt-16 pb-12 text-center">
        <h1 className="text-4xl font-bold tracking-tight text-fg-primary mb-4">
          Level Up Your Style
        </h1>
        <p className="text-lg text-fg-secondary mb-8 max-w-md mx-auto">
          A gamified fashion education app for modern gentlemen
        </p>
        <Link
          to="/auth"
          className="btn-primary inline-flex items-center justify-center px-8 py-3 text-lg"
        >
          Get Started Free
        </Link>
      </section>

      {/* Features Section */}
      <section className="px-5 py-12">
        <h2 className="text-2xl font-semibold text-center text-fg-primary mb-8">
          Everything you need to dress better
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {features.map((feature) => (
            <div key={feature.title} className="bg-surface rounded-lg shadow-glass p-6">
              <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center mb-4">
                <feature.icon className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="text-lg font-semibold text-fg-primary mb-2">{feature.title}</h3>
              <p className="text-fg-secondary">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Preview Links */}
      <section className="px-5 py-12 bg-surface">
        <h2 className="text-2xl font-semibold text-center text-fg-primary mb-4">
          Try before you sign up
        </h2>
        <p className="text-center text-fg-secondary mb-8">
          Browse our educational content and challenges
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/education"
            className="btn-ghost inline-flex items-center justify-center px-6 py-3"
          >
            <BookOpenIcon className="w-5 h-5 mr-2" />
            Browse Education
          </Link>
          <Link
            to="/challenges"
            className="btn-ghost inline-flex items-center justify-center px-6 py-3"
          >
            <ViewfinderCircleIcon className="w-5 h-5 mr-2" />
            View Challenges
          </Link>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="px-5 py-16 text-center">
        <h2 className="text-2xl font-semibold text-fg-primary mb-4">
          Ready to transform your style?
        </h2>
        <Link to="/auth" className="btn-primary inline-flex items-center justify-center px-8 py-3">
          Sign Up Now
        </Link>
      </section>
    </main>
  )
}
